<template>
  <v-container fluid grid-list-md>
    <v-toolbar flat color="white">
      <v-toolbar-title>Dashboard</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-layout row wrap>
      <v-flex d-flex xs12 sm6 md4>
        <v-card color="white">
          <br/>
          <v-img
          src="https://liefermax.com/wp-content/uploads/2017/06/cropped-trans_wortmarke_icon.png"
          aspect-ratio="5"
          style="width: 80%; margin: auto;"
        ></v-img>
           <v-card-title primary-title>
             <div style="margin: auto;">
                <br/>
                <p style="text-align: center;">
                  <br/>
                  LieferMax GmbH <br/>
                  An der Leiten 4 <br/>
                  87672 Roßhaupten <br/>
                  08367 - 149 36 17 <br/>
                  <br/>
                  <a href="mailto:info@liefermax.com">info@liefermax.com</a>
                  <br/>
                  <br/>
                  <br/>
                  Ihr Ansprechpartner:
                  <br/>
                  <b>Josef Strobel</b>
                </p>
             </div>
           </v-card-title>
        </v-card>
      </v-flex>
      <v-flex d-flex xs12 sm6 md3>
        <v-layout row wrap>
          <v-flex d-flex>
            <v-card color="blue-grey darken-2" class="white--text">
              <v-card-title primary-title>
                <div>
                  <div class="headline">Angelegte Geräte</div>
                  <br/>
                  <hr>
                  <br/>
                  <span>LieferMax hat Ihnen bisher auf <b>{{ totalDevices }}</b> unterschiedlichen Geräten den Alltag der Fahrer vereinfacht.</span>
                </div>
              </v-card-title>
              <br/>
            </v-card>
          </v-flex>
          <v-flex d-flex>
            <v-card color="deep-orange darken-4" class="white--text">
              <v-card-title primary-title>
                <div>
                  <div class="headline">Erfasste Standortdaten</div>
                  <br/>
                  <hr>
                  <br/>
                  <span>LieferMax hilft Ihnen bei der Kontrolle der Touren. Aktuell befinden sich <b>{{ totalLocations }}</b> Standortdaten der iPads in der Datenbank.</span>
                </div>
              </v-card-title>
              <br/>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex d-flex xs12 sm6 md3>
        <v-layout row wrap>
          <v-flex d-flex>
            <v-card color="blue lighten-5" class="dark--text">
              <v-card-title primary-title>
                <div>
                  <div class="headline">Gefahrene Strecke</div>
                  <br/>
                  <hr>
                  <br/>
                  <span>Ihre Fahrzeuge sind insgesamt {{ allStats.complete_kmdriven }} km mit LieferMax unterwegs gewesen. Dadurch entstanden bei Durchschnittlich 1,50€ / km Kosten in Höhe von {{ allStats.complete_kmdriven * 1.5 }} €.</span>
                </div>
              </v-card-title>
              <br/>
            </v-card>
          </v-flex>
          <v-flex d-flex>
            <v-card color="teal darken-1" class="white--text">
              <v-card-title primary-title>
                <div>
                  <div class="headline">Aufträge</div>
                  <br/>
                  <hr>
                  <br/>
                  <span>Die Fahrer konnten durch LieferMax {{ totalContracts }} Aufträge erledigen. Die Aufträge wurden in insgesamt {{ totalTours }} Touren zusammengefasst.</span>
                </div>
              </v-card-title>
              <br/>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'dashboard',
  data() {
    return {
      totalLocations: 0,
      totalDevices: 0,
      totalTours: 0,
      totalContracts: 0,
      allStats: {}
    };
  },
  watch: {
    locations(newValue, oldValue) {
      console.log(newValue.items.total);
      this.totalLocations = newValue.items.total;
    },
    devices(newValue, oldValue) {
      this.totalDevices = newValue.items.total;
    },
    tours(newValue, oldValue) {
      this.totalTours = newValue.items.total;
    },
    contracts(newValue, oldValue) {
      this.totalContracts = newValue.items.total;
    },
    stats(newValue, oldValue) {
      console.log(newValue);
      this.allStats = newValue.items;
    }
  },
  computed: {
    tours() {
      return this.$store.state.tours.all;
    },
    locations() {
      return this.$store.state.locations.all;
    },
    devices() {
      return this.$store.state.devices.all;
    },
    contracts() {
      return this.$store.state.contracts.all;
    },
    stats() {
      return this.$store.state.tours.stats;
    }
  },
  mounted() {
    this.getDataFromApi();
  },
  methods: {
    getDataFromApi() {
      const perpage = 5;
      const page = 1;
      const sortby = 'bla';
      const descending = true;

      this.$store.dispatch('devices/getAll', {
        perpage,
        page,
        sortby,
        descending
      });
      this.$store.dispatch('locations/getAll', {
        perpage,
        page,
        sortby,
        descending
      });
      this.$store.dispatch('contracts/getAll', {
        perpage,
        page,
        sortby,
        descending
      });
      this.$store.dispatch('tours/getAll', {
        perpage,
        page,
        sortby,
        descending
      });
      this.$store.dispatch('tours/getStats');
    }
  }
};
</script>
